import React from "react";

/**
 * Gantari Edu Logo — Abstract fusion of:
 *  - Upward path (golden growth diagonal) = ambisi pertumbuhan
 *  - Radiance/4-point star at the peak = "Gantari" (menyala/shining)
 *  - Small sparkle dots = jaringan peluang
 */
export default function Logo({ size = 40, withText = true, dark = false, className = "" }) {
    const accent = "#F5A623";
    return (
        <div className={`flex items-center gap-2.5 ${className}`} data-testid="brand-logo">
            <svg
                width={size}
                height={size}
                viewBox="0 0 40 40"
                xmlns="http://www.w3.org/2000/svg"
                aria-label="Gantari Edu"
            >
                <defs>
                    <linearGradient id="gnt-path" x1="0%" y1="100%" x2="60%" y2="0%">
                        <stop offset="0%" stopColor={accent} stopOpacity="0.35" />
                        <stop offset="100%" stopColor={accent} stopOpacity="1" />
                    </linearGradient>
                    <radialGradient id="gnt-glow" cx="50%" cy="50%" r="50%">
                        <stop offset="0%" stopColor={accent} stopOpacity="0.45" />
                        <stop offset="100%" stopColor={accent} stopOpacity="0" />
                    </radialGradient>
                </defs>
                <rect width="40" height="40" rx="11" fill="#0A1A2F" />
                {/* Subtle inner glow behind the star */}
                <circle cx="22" cy="14" r="11" fill="url(#gnt-glow)" />
                {/* Upward growth path */}
                <path
                    d="M9.5 30 L22 14"
                    stroke="url(#gnt-path)"
                    strokeWidth="3"
                    strokeLinecap="round"
                    fill="none"
                />
                {/* 4-point radiance star */}
                <g transform="translate(22 14)">
                    <path d="M0 -6 L0 6" stroke={accent} strokeWidth="2.2" strokeLinecap="round" />
                    <path d="M-6 0 L6 0" stroke={accent} strokeWidth="2.2" strokeLinecap="round" />
                    <path
                        d="M-3.8 -3.8 L3.8 3.8"
                        stroke={accent}
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        opacity="0.7"
                    />
                    <path
                        d="M3.8 -3.8 L-3.8 3.8"
                        stroke={accent}
                        strokeWidth="1.4"
                        strokeLinecap="round"
                        opacity="0.7"
                    />
                    <circle r="1.6" fill="#0A1A2F" stroke={accent} strokeWidth="1.1" />
                </g>
                {/* Sparkle dots */}
                <circle cx="29" cy="22" r="1.1" fill={accent} opacity="0.75" />
                <circle cx="14" cy="17" r="0.9" fill={accent} opacity="0.55" />
                <circle cx="32" cy="11" r="0.7" fill={accent} opacity="0.6" />
            </svg>
            {withText && (
                <span
                    className={`font-display font-bold text-xl tracking-tight ${
                        dark ? "text-white" : "text-[#0A1A2F]"
                    }`}
                >
                    Gantari<span className="text-[#F5A623]">Edu</span>
                </span>
            )}
        </div>
    );
}
